module.exports = "/_next/static/images/img-result-win-fd409ee9.png";